import { formatISODate, parseISODate, getYear } from "../date";
import addWeeks from "date-fns/addWeeks";
import subYears from "date-fns/subYears";
import { historyBus } from "../history-manager";

/**
 * Calendar
 */
export default function scheduleCalendar(el, props) {
  const triggerEl = el.querySelector(props.triggerEl);
  const containerEl = el.querySelector(props.containerEl);
  const baseUrl = props.baseUrl;
  const platformId = props.platformId;

  const defaultDate = props.allowBlank ? null : new Date();
  const selectedDate = props.selectedDate
    ? parseISODate(props.selectedDate)
    : defaultDate;

  const minSelectableDate = subYears(new Date(), 1);
  const maxSelectableDate = addWeeks(new Date(), 1);

  let picker;

  import("../vendor/pikaday").then(({ default: Pikaday }) => {
    picker = new Pikaday({
      bound: false,
      defaultDate: selectedDate,
      setDefaultDate: selectedDate,
      container: containerEl,
      field: triggerEl,
      firstDay: 1,
      minDate: minSelectableDate,
      maxDate: maxSelectableDate,
      yearRange: [2017, getYear()],
      onSelect: function(date) {
        let url = `${baseUrl}?date=${formatISODate(date)}`;

        if (platformId) {
          url = url + `&platform_id=${platformId}`;
        }

        historyBus.visit(url);
      }
    });
  });

  return {
    destroy: () => {
      if (picker) {
        picker.destroy();
      }
    }
  };
}
